var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',_vm._b({staticClass:"md-dense file-button-hidden"},'md-button',_vm.$attrs,false),[_vm._t("default"),_c('input',{attrs:{"type":"file","accept":_vm.$attrs.accept},on:{"change":_vm.onChange}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }